export const mockClients = [
  {
    CreateTime: "2025-06-05T07:25:24.742409+00:00",
    Clients: null,
    Tags: [
      { Type: 0, Id: 616, Name: "PUBLIC HOSP" },
      { Type: 0, Id: 619, Name: "PARTNER" },
      { Type: 0, Id: 44, Name: "ЗАСТРОЙЩИК" },
    ],
    AddressChain: ["Москва"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "",
        },
        ListTitle: null,
      },
    ],
    Id: 30161,
    Name: "тестовый клиент клиника",
  },
  {
    CreateTime: "2024-09-09T14:50:28.937611+00:00",
    Clients: null,
    Tags: [],
    AddressChain: ["Москва"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "9709022233",
        },
        ListTitle: null,
      },
    ],
    Id: 30149,
    Name: "Издательство ООО Оппонент",
  },
  {
    CreateTime: "2024-09-09T13:46:24.56243+00:00",
    Clients: [{ Id: 27141, Name: "ООО Генезис М" }],
    Tags: [{ Type: 0, Id: 619, Name: "PARTNER" }],
    AddressChain: ["Ростов-на-Дону"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "6165147077",
        },
        ListTitle: null,
      },
    ],
    Id: 30148,
    Name: "ООО Пересвет",
  },
  {
    CreateTime: "2024-09-09T11:51:21.454328+00:00",
    Clients: null,
    Tags: [],
    AddressChain: ["Истра"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "5032353199",
        },
        ListTitle: null,
      },
    ],
    Id: 30147,
    Name: "АНОО ОБЛАСТНОЙ ТЕХНОЛИЦЕЙ ИМЕНИ В И ДОЛГИХ",
  },
  {
    CreateTime: "2024-09-09T10:30:43.888516+00:00",
    Clients: null,
    Tags: [{ Type: 0, Id: 7, Name: "PRIVATE HOSP" }],
    AddressChain: ["Москва"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "7736128789",
        },
        ListTitle: null,
      },
    ],
    Id: 30146,
    Name: "АНО МЕЖДУНАРОДНАЯ КЛИНИКА КАРДИОАНГИОЛОГИИ",
  },
  {
    CreateTime: "2024-09-09T10:00:21.182578+00:00",
    Clients: null,
    Tags: [],
    AddressChain: ["Москва"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "7723432277",
        },
        ListTitle: null,
      },
    ],
    Id: 30145,
    Name: "ООО КЛИНИКА ОСТЕОПАТИИ КАМЕРТОН",
  },
  {
    CreateTime: "2024-09-09T09:55:30.270321+00:00",
    Clients: null,
    Tags: [],
    AddressChain: ["Москва"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "7736325748",
        },
        ListTitle: null,
      },
    ],
    Id: 30144,
    Name: "ООО ИРТЫШ МЕДИКАЛ",
  },
  {
    CreateTime: "2024-09-09T09:11:21.66834+00:00",
    Clients: null,
    Tags: [],
    AddressChain: ["Казань"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "1659214422",
        },
        ListTitle: null,
      },
    ],
    Id: 30143,
    Name: "ООО Тайфун",
  },
  {
    CreateTime: "2024-09-09T09:05:05.625426+00:00",
    Clients: null,
    Tags: [{ Type: 0, Id: 619, Name: "PARTNER" }],
    AddressChain: ["Москва"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "343512972833",
        },
        ListTitle: null,
      },
    ],
    Id: 30142,
    Name: "ИП Меркушева Людмила Игоревна",
  },
  {
    CreateTime: "2024-09-09T08:19:23.547969+00:00",
    Clients: null,
    Tags: [],
    AddressChain: ["Солнечногорский район"],
    Parameters: [
      {
        UsedInSearch: true,
        Type: 0,
        Instance: {
          IsRecord: false,
          RecordFields: null,
          Key: "Tax ID (ИНН)",
          Value: "504408795467",
        },
        ListTitle: null,
      },
    ],
    Id: 30141,
    Name: "ИП Волкова Валерия Михайловна ( вет-клиника Фламинго)",
  },
];
